module.exports = __webpack_public_path__ + "img/popup_button2_unselected.afaad9f7.png";